import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import MainSidebar from '../components/MainSidebar';
import rightarrow from '../assets/images/right.svg';
import config from '../config/config';

const NotificationSettings = () => {
  const [userData, setUserData] = useState({ email: '', user_name: '' });
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [activityStatus, setActivityStatus] = useState(false);
  const [subscriptionStatus, setSubscriptionStatus] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/Login');
      return;
    }

    const fetchUserDetails = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/current-user-details`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const user = response.data.data.user;
        const userDetails = response.data.data.user_details;
        setUserData(user);
      } catch (error) {
        console.error('Error fetching user details', error);
      }
    };

    fetchUserDetails();
  }, [navigate]);


  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };


  return (
    <div>
      <div className="main_patreonpass_wrapper">
        <div className="patreonpass_container">
          <div className="left_sidebar">
            <MainSidebar />
          </div>
          <div className="patreonpass_main_content edit_profile_settings" id="content">
            <div className="left_main_content">
              <div className="feed_wrapper">
                <div className="page_title_with_dropdown notification_page">
                  <div className="page_heading">
                    <button className="profile_back_btn" onClick={handleBackClick}>
                      <svg width={54} height={54} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M48 27.5363L5.99998 27.5363M5.99998 27.5363L27 49.0532M5.99998 27.5363L27 6.3032" stroke="#222" strokeWidth={6} strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                    <h1>SETTINGS</h1>
                  </div>
                </div>
                <div className="menus_all_wrapper">
                  <div className="edit_settings_menu_list">
                    <h3><a href={`/${userData.user_name}`}>@{userData.user_name}</a></h3>
                     <ul>
                      <li><Link to="/EditProfile">Profile <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      <li><Link to="/AccountSettings">Account <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      <li><Link to="/PrivacySafetySettings">Privacy and safety <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      <li><Link className="active_profile_menu" to="/NotificationSettings">Notifications <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="right_main_content">
                <div className="page_title_with_dropdown notification_page">
                  <div className="page_heading">                    
                    <h1>NOTIFICATIONS</h1>
                  </div>
                </div>
                <div className="edit_username_field with_top_fixed_heading privacysafetysettings">
                  <div className="fields_menu_bottom_box_security">
                    <div className="edit_settings_menu_list">
                      <h3> Preferences </h3> 
                      <ul>
                        <li>
                          <Link to="/EmailNotificationSettings">
                            
                            Email notifications
                            <span className="menu_arrow">
                              <img src={rightarrow} alt="" />
                            </span>
                          </Link>
                        </li>
                        <li>
                         <Link to="/SiteNotificationSettings">
                            
                            Site notifications
                            <span className="menu_arrow">
                              <img src={rightarrow} alt="" />
                            </span>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationSettings;
